<template>
    <div>
        <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
            <!-- Card stats -->
            <div class="row">
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Total traffic"
                                type="gradient-red"
                                sub-title="350,897"
                                icon="ni ni-active-40"
                                class="mb-4 mb-xl-0">

                        <template slot="footer">
                            <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> 3.48%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template>
                    </stats-card>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Total traffic"
                                type="gradient-orange"
                                sub-title="2,356"
                                icon="ni ni-chart-pie-35"
                                class="mb-4 mb-xl-0">

                        <template slot="footer">
                            <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> 12.18%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template>
                    </stats-card>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Sales"
                                type="gradient-green"
                                sub-title="924"
                                icon="ni ni-money-coins"
                                class="mb-4 mb-xl-0">

                        <template slot="footer">
                            <span class="text-danger mr-2"><i class="fa fa-arrow-down"></i> 5.72%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template>
                    </stats-card>

                </div>
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Performance"
                                type="gradient-info"
                                sub-title="49,65%"
                                icon="ni ni-chart-bar-32"
                                class="mb-4 mb-xl-0">

                        <template slot="footer">
                            <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> 54.8%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template>
                    </stats-card>
                </div>
            </div>
        </base-header>

        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col-lg-3">
                    <h3 class="my-4">Order Information</h3>
                    <div class="card">
                        <table class="table mb-0 table-responsive">
                            <tbody v-for="ord in order" :key="ord.id">
                            <tr>
                                <th>Order Number</th>
                                <td>{{ord.orderNo}}</td>
                            </tr>
                            <tr>
                                <th>Customer Location</th>
                                <td>{{ord.county}}</td>
                            </tr>
                            <tr>
                                <th>Customer Address</th>
                                <td>{{ord.address}}</td>
                            </tr>
                           <tr>
                                <th>Status</th>
                                <td>
                                    <span v-if="ord.status == 'pending'"
                                          style="color: blue;">{{ord.status}}</span>
                                    <span v-if="ord.status == 'cancelled'"
                                          style="color: red;">{{ord.status}}</span>
                                    <span v-if="ord.status == 'completed'"
                                          style="color: green;">{{ord.status}}</span>
                                    <span v-if="ord.status == 'in-transit'"
                                          style="color: yellow;">{{ord.status}}</span>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>

                </div>
                <div class="col-lg-9">
                    <div class="card mt-4">
                        <div class="card-body">
                            <table class="table mb-0">
                                <tbody v-for="detail in details" :key="detail.id">
                                <tr>
                                    <th>item Name</th>
                                    <td>{{detail.title}}</td>
                                </tr>

                                <tr>
                                    <th>category</th>
                                 <td>{{detail.category.name}}</td>
                                </tr>

                                <tr>
                                    <th>sub category</th>
                                  <td>{{detail.subcategory.name}}</td>
                                </tr>

                                <tr>
                                    <th>Brand</th>
                                  <td>{{detail.brand.name}}</td>
                                </tr>
                                <tr>
                                    <th>Price</th>
                                    <td>{{detail.price}}</td>
                                </tr>

                                </tbody>
                            </table>
                        </div>
                    </div>
                    <!-- /.card -->

                  <!--<div class="card card-outline-secondary my-4">
                        <div class="card-header">
                            Items in order
                        </div>
                        <div class="card-body table-responsive">
                            <table class="table table-hover shopping-cart-wrap">
                                <thead class="text-muted">
                                <tr>
                                    <th scope="col">Product</th>
                                    <th scope="col" width="120">Quantity</th>
                                    <th scope="col" width="120">Price (Ksh)</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="detail in details" :key="detail.id">
                                    <td>
                                        <figure class="media">
                                            <div class="img-wrap"><img :src="item.product.files[0].filePath"
                                                                       class="img-thumbnail img-sm"
                                                                       style="width: 90px;">
                                            </div>
                                            <figcaption class="media-body pl-3">
                                                <h6 class="title text-truncate">{{detail.title}}</h6>
                                                <dl v-if="item.product.quantity" class="param param-inline small">
                                                    <dt>Quantity:</dt>
                                                    <dd>{{item.product.quantity}}</dd>
                                                </dl>
                                            </figcaption>
                                        </figure>
                                    </td>
                                    <td>
                                        {{item.quantity}}
                                    </td>
                                    <td>
                                        <div class="price-wrap">
                                            <var class="price">{{item.quantity * item.product.price}}</var>
                                            <small class="text-muted">({{Math.round(item.product.price)}} each)</small>
                                        </div> &lt;!&ndash; price-wrap .// &ndash;&gt;
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>-->
                    <!-- /.card -->

                </div>
                <!-- /.col-lg-9 -->

            </div>
        </div>

    </div>
</template>
<script>
    let moment = require('moment');
    export default {
        name: 'ShoppingOrderInfo',
        components: {},
        data() {
            return {
                moment,
                orderNo: this.$route.params.id,
                details: [],
                order:[],

            }
        },
        methods: {
            changeStatus(event) {
                this.form.status = event.target.value;
                this.$swal.fire({
                    title: 'Mark as ' + this.form.status + '?',
                    text: "You won't be able to revert this!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, update status!',
                }).then((result) => {
                    // send the request to the controller
                    if (result.value) {
                        this.axios.patch("/admin/shopLocal/change-status/" + this.orderNo, this.form).then(() => {
                            this.$swal.fire(
                                'Success!',
                                'Status updated successfully',
                                'success'
                            )
                            this.getDetails();
                        });
                    }
                }).catch(() => {
                    this.$swal("Failed!", "There was something wrong.", "warning");
                })
            },
            getDetails() {
                this.axios.get('/retailer/dashboard/order-details/' + this.orderNo)
                    .then((response) => {
                        this.details = response.data
                    })
                    .catch(() => {

                    })
            },
            getOrders(){
                this.axios.get('/retailer/dashboard/showOrderDetails/' + this.orderNo).then(({data})=> ([this.order = data]))
            },
        },
        created() {
            this.getDetails();
            this.getOrders();
        }

    };
</script>
<style></style>
